/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon16Regular = forwardRef('LogoTwitterIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.82 3.238a.75.75 0 1 0-1.14-.976l-3 3.501-2.62-3.465A.75.75 0 0 0 5.46 2h-2.86A.75.75 0 0 0 2 3.202l4.16 5.5-3.48 4.06a.75.75 0 0 0 1.139.976l3.266-3.811 2.855 3.775a.75.75 0 0 0 .598.298H13.4a.75.75 0 0 0 .598-1.202l-4.392-5.81 3.213-3.75ZM10.912 12.5l-6.805-9h.98l6.806 9h-.98Z" })));
});
